
import axios from "axios";
import { mainBaseUrl } from "@/apis/appconst";

const apiBaseUrl = mainBaseUrl + "api/v1";
import Cookies from "js-cookie";

export async function createTripSchedule(
  bus_id,
  route_id,
  trips
) {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.post(
      `${apiBaseUrl}/trip/`,
      {
        bus_id,
        route_id,
        trips,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      message: "Trip schedule created successfully.",
      data: response.data,
    };
  } catch (error) {
    console.log("error", error);

    return {
      success: false,
      type: "danger",
      message: error.response.data.error,
    };
  }
}

export async function deleteTripById(trip_id) {
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.delete(
      `${apiBaseUrl}/trip/${trip_id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      message: "Trip deleted successfully.",
      data: response.data,
    };
  } catch (error) {
    console.log("error", error);

    return {
      success: false,
      type: "danger",
      message: error.response?.data?.error || "Failed to delete trip.",
    };
  }
}

export async function editTripById(trip_id, updatedData) {
 if (updatedData?.editable) {
        delete updatedData.editable; 
    }
    
  const token = Cookies.get("accessToken");
  try {
    const response = await axios.put(
      `${apiBaseUrl}/trip/${trip_id}`,
      updatedData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return {
      success: true,
      type: "success",
      message: "Trip updated successfully.",
      data: response.data,
    };
  } catch (error) {
    console.log("error", error);

    return {
      success: false,
      type: "danger",
      message: error.response?.data?.error || "Failed to update trip.",
    };
  }
}
